import { inject } from '@angular/core';
import { CanMatchFn, Router, Route, UrlSegment } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { MenuService } from '../../menu.service';

export const userAccessGuard: CanMatchFn = (
  route: Route,
  segments: UrlSegment[]
) => {
  const authService = inject(AuthService);
  const menuService = inject(MenuService);
  const router = inject(Router);
 

  const userId = authService?.currentUserValue?.id;
   const roleId = authService?.currentUserValue?.roleId;
  if (!userId) {
    return of(router.parseUrl('/access-denied'));
  }
  const fullPath = '/' + segments.map((s) => s.path).join('/');

  return menuService.getMenuByUserId(roleId).pipe(
    map((response: any) => {
      const allowedPaths = response?.data?.filter(
        (x: any) => x.isChecked === true
      );
      const allowedRoutes =
        allowedPaths?.map((item: any) => item.menuLink) || [];

      // Match exactly or check if current path starts with any allowed menu link
      // const hasAccess = allowedRoutes.some(
      //   (allowed: string) =>
      //     fullPath === allowed || fullPath.startsWith(allowed)
      // );

      const normalize = (path: string) => path.replace(/\/+$/, '');

      const hasAccess = allowedRoutes.some(
        (allowed: string) =>
         normalize(fullPath) === normalize(allowed) ||
         normalize(fullPath).startsWith(normalize(allowed))
       );


      return hasAccess ? true : router.parseUrl('/access-denied');
    }),
    catchError(() => of(router.parseUrl('/access-denied')))
  );
};
